import { Component, OnInit } from '@angular/core';
import { Service } from '../../service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormBuilder } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { IQuestions } from 'src/app/questions';


@Component({
  selector: 'app-question',
  templateUrl: './question.component.html',
  styleUrls: ['./question.component.scss']
})
export class QuestionComponent implements OnInit {
  name: string = '';
  advisors;

  // The question, which will be displayed
  question;
  progressnumber: number = 10;
  counter: number = 0;
  isShown: boolean = false;


  // A form group used to handle the answers as option inputs
  form: FormGroup;
  browserLang: string;
  questions;
  logo: any;
  singleQuestion: IQuestions;
  questionsList = [];
  advisor: any;
  advisorsList = [];
  advisorName: any;

  constructor(
    public quiz: Service,
    public route: ActivatedRoute,
    public FB: FormBuilder,
    public router: Router,
    public translate: TranslateService,

  ) {
    this.changeLang(this.translate.currentLang);
    this.getAdvisors();

    /*
      2. Subscribe to routing events. By doing so, everytime your user is being routed, an event will be triggered. Because you declared a parameter in your routes, you have a dynamic URL : this allows you to query the right question.

      Go to question.component.html
    */
    this.route.paramMap.subscribe(params => {
      // Get the question ID and store it.
      this.quiz.questionId = +params.get('questionId')

      // Call change Lang method to subscribe data and set language
      this.changeLang(this.translate.currentLang);

      // If there is no more question, navigate to show the answers
      if (this.quiz.questionId > 11 - 1) {
        this.router.navigate(['/', this.translate.currentLang, 'advisor', this.advisorName, 'answers']);

      }

      // Set the current question to be displayed and create a form group.
      this.form = this.FB.group({
        answer: ''
      });
    });


  }


  getAdvisors(): void {
    this.quiz.getAdvisors()
      .subscribe(advisor => {
        this.advisors = advisor;
        this.getAdvisor();

      });

  }
  getAdvisor() {
    this.advisor = this.advisors;

    const name = this.route.snapshot.paramMap.get('name');

    //loop through questions
    for (var i = 0; i < this.advisor?.advisor.length; i++) {
      this.advisorsList[i] = this.advisor.advisor[i];
    }


    this.advisor = this.advisorsList.filter(
      x => x.name === name);
    this.advisorName = this.advisor[0].name;

    if (this.advisor == undefined) {
      this.router.navigate(['/pageNotFound']);
      return;
    }

  }

  ngOnInit(): void {

  }

  changeLang(lang: string) {
    this.quiz.changeLang(lang);

      //Subscrbe to getQuestions() - Go to Service.ts
      this.quiz.getQuestions()
        .subscribe(questionsData => {
          this.questions = questionsData;

          // Call Sort message to pass this.questions value
          this.findQuestions();
          this.logo = this.questions.homePage[0].FRLOGO;
        });
  }
  //Filter through this.questionsList and match is match it with questions ID 
  findQuestions() {
    //put questions list in question object 
    this.quiz.questions = this.questions.questions;

    //loop through questions
    for (var i = 0; i < this.questions.questions.length; i++) {
      this.questionsList[i] = this.questions.questions[i];
    }

    this.question = this.questionsList.filter(
      x => x.id === this.quiz.questionId);
  }

}